import { Dispatch, ReducerState, ReducerAction, createContext } from "react";
import AlertsReducer from "./alerts.reducer";

type AlertsReducerState = ReducerState<typeof AlertsReducer>;
type AlertsDispatchAction = Dispatch<ReducerAction<typeof AlertsReducer>>;
type AlertsContextType = [AlertsReducerState, AlertsDispatchAction];

export const AlertsContext = createContext<AlertsContextType>([{ alert: null }, (state) => state]);
